<template>
  <popup
    title="ВЫБЕРИТЕ НАПРАВЛЕНИЕ"
    :styles="{
      'width': '1062px'
    }"

    :value="value"
    :currentPoint="currentPoint"
    @input="$emit('input', $event)"
  >
    <template v-slot:content>
      <div class="faculties">
        <vuescroll
          :ops="ops"
          ref="vs"
          class="faculties__wrapper"
        >
          <div
            class="row row--faculties"
            slot="scroll-content"
          >
            <div
              class="row__column column"
              v-for="faculty in Faculties"
              :key="faculty.id"
            >
              <div
                :class="['faculty-content', 'click-sound', {
                  'selected': getSelectedFaculty(faculty.id)
                }]"
                @click="choiceFaculty(faculty)"
              >
                <div class="faculty-content__wrapper click-sound">
                  <div
                    :class="['faculty-content__image',
                      `faculty-content__image--${faculty.id - 1}`,
                      'click-sound'
                    ]"
                  />
                </div>
                <div class="faculty-content__info click-sound">
                  <p class="faculty-content__name click-sound">
                    {{ faculty.name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </vuescroll>
      </div>
    </template>
    <template v-slot:footer>
      <button
        class="btn click-sound"
        @click="continueQuest"
        :disabled="selectedFaculties.length === 0"
      >
        Выбрать
      </button>
    </template>
  </popup>
</template>

<script>
  import vuescroll from 'vuescroll'
  import Popup from '@/components/Popup'
  import { Faculties } from '@/data'

  export default {
    components: {
      vuescroll,
      Popup
    },
    props: {
      value: {
        type: [Boolean, String],
        default: false
      }
    },
    data(){
      return {
        Faculties,
        selectedFaculties: [],
        currentPoint: 1,
        ops: {
          vuescroll: {
            detectResize: false
          },
          scrollPanel: {
            scrollingX: false
          },
          rail: {
            size: '13px',
            opacity: '.5',
            specifyBorderRadius: '0px',
            gutterOfEnds: '0px',
            gutterOfSide: '0px',
            background: '#000716'
          },
          bar: {
            size: '13px',
            opacity: '1',
            background: '#000716',
            keepShow: true
          }
        }
      }
    },
    watch: {
      value(value){
        if(!value) setTimeout(() => {
          this.selectedFaculties = [];
          this.$refs.vs.scrollTo({y: 0});
        }, 500);
      }
    },
    methods: {
      choiceFaculty(faculty){
        if(!this.getSelectedFaculty(faculty.id) && this.selectedFaculties.length != 3) this.selectedFaculties.push(faculty);
        else if(this.getSelectedFaculty(faculty.id)) this.selectedFaculties = this.selectedFaculties.filter(el => el !== faculty);
      },
      getSelectedFaculty(facultyId){
        return this.selectedFaculties.find(faculty => faculty.id === facultyId);
      },
      continueQuest(){
        if(!this.selectedFaculties.length) return;

        this.currentPoint = 2;
        this.$emit('continueQuest', true, 2, this.selectedFaculties);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .faculties {

    &__wrapper {
      height: 600px !important;
    }
  }
  .faculty-content {
    position: relative;
    display: flex;
    cursor: pointer;
    background: rgba(0, 7, 22, .5);
    user-select: none;

    &.selected {
      box-shadow: 0 0 15px rgba(255, 255, 255, .25);
    }
    &::after {
      position: absolute;
      display: none;
      content: '';
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border: 2px solid #FFF;
      box-shadow: inset 0 0 20px rgba(255, 255, 255, .5);
    }
    &.selected::after {
      display: block;
    }
    &__image {
      display: block;
      width: 112px;
      height: 112px;
      background-image: url(/images/faculties/faculties-icons.png);
      background-repeat: no-repeat;
      background-size: auto 112px;
      pointer-events: none;
      overflow: hidden;
    }
    @for $i from 0 through 20 {
      &__image--#{$i} { background-position: -$i * 112px 0; }
    }
    &__wrapper {
      position: relative;
      overflow: hidden;
    }
    &__info {
      position: relative;
      display: flex;
      width: calc(100% - 112px);
      padding: 10px 25px;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }
    &__name {
      text-align: center;
      line-height: 1.3;
      font-family: 'ProximaNova';
      font-size: 23px;
      color: #FFF;
    }
    &.selected &__name {
      text-shadow: 0 0 15px rgba(255, 255, 255, .5);
    }
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    &__item {
      width: 107px;
      margin: 10px 5px 0;
      cursor: pointer;

      &:nth-child(-n+8) {
        margin-top: 0;
      }
    }
    &__wrapper {
      position: relative;
      margin-bottom: 10px;
      overflow: hidden;
      z-index: 1;

      &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,.7);
        transform: scale(0);
        border-radius: 50%;
        transition: transform .2s;
      }
      &.selected {

        &:after {
          transform: scale(2);
        }
      }
    }
    &__image {
      width: 107px;
      height: 112px;
    }
    &__name {
      text-align: center;
      font-size: 13px;
    }
  }
</style>
